import { Injectable } from "@angular/core";
import {
	Beneficiaire,
	MobileEntourage,
	MobileIntervenant,
	MobilePatient,
	Sexe,
} from "@jack-sparrow-libraries/emotion-models";
import { PatientModalAyService } from "features";
import { SexeNewCvPatientQuestionComponent } from "@featuresAY/patient-web-ay/modals/sexe-new-cv-patient-question/sexe-new-cv-patient-question.component";
import { CbaAlertDialogWebComponent } from "@featuresAY/ordonnance-web-ay/components/cba-alert-dialog-web/cba-alert-dialog-web.component";
import { DatePipe } from "@angular/common";
import { ConfirmationCreationModalAyComponent } from "@featuresAY/patient-web-ay/modals/confirmation-creation-modal-ay/confirmation-creation-modal-ay.component";
import { UIKitDialogConfig, UiKitDialogService } from "@jack-sparrow-libraries/ui-kit";
import { firstValueFrom } from "rxjs";

@Injectable({
	providedIn: "root",
})
export class PatientModalAyServiceImpl implements PatientModalAyService {
	constructor(
		private datePipe: DatePipe,
		private dialogService: UiKitDialogService,
	) {}

	async confirmPatientCreation(beneficiaire: Beneficiaire) {
		const dialogRef = this.dialogService.openDialog(CbaAlertDialogWebComponent, {
			closeButton: false,
			noMargin: true,
			noPadding: true,
			inputs: {
				data: {
					title: "Es-tu sûr ?",
					alertType: "warning",
					alertTitle: `Veux-tu créer le patient <p>${beneficiaire.nomUsuelBeneficiaire} ${beneficiaire.nomUsuelBeneficiaire} </p>`,
					confirmBtnText: "Confirmer",
					cancelBtnText: "Revenir au choix des bénéficiaires",
				},
			},
		});
		return await firstValueFrom(dialogRef.afterClosed());
	}

	async choosePatientSexe(): Promise<Sexe | null | undefined> {
		return await firstValueFrom(
			this.dialogService
				.openDialog(SexeNewCvPatientQuestionComponent, { closeButton: false, noPadding: true })
				.afterClosed(),
		);
	}
	async completeInfoPatient(patient?: MobilePatient, isNew = false) {
		const dialogConfig: UIKitDialogConfig = {
			title: ` ${patient.sexe === "Femme" ? "La patiente" : "Le patient"}  ${patient.nom.toUpperCase()} ${
				patient.prenom
			} a bien été ${
				!isNew
					? patient.sexe === "Femme"
						? "mise à jour"
						: "mis à jour"
					: patient.sexe === "Femme"
						? " créée"
						: " créé"
			} !`,
			closeButton: false,
			radius: "lg",
		};
		return this.dialogService
			.openDialog(ConfirmationCreationModalAyComponent, dialogConfig)
			.afterClosed()
			.toPromise();
	}
	async completeInfoEtablissementSoins() {
		throw new Error("Method not implemented.");
	}
	async patientPartielAlert() {
		throw new Error("Method not implemented.");
	}
	async addEditIntervenant(
		edit: boolean,
		intervenant?: MobileIntervenant,
	): Promise<{ data: MobileIntervenant; role: string }> {
		throw new Error("Method not implemented.");
	}
	async addEditEntourage(
		edit: boolean,
		entourage?: MobileEntourage,
	): Promise<{ data: MobileEntourage; role: string }> {
		throw new Error("Method not implemented.");
	}
	async chooseSiecleNaissance(patient: MobilePatient) {
		throw new Error("Method not implemented.");
	}
	async addOrdoOrAct() {
		throw new Error("Method not implemented.");
	}

	async patientIsDoublon(patientExistant: MobilePatient) {
		const dialogRef = this.dialogService.openDialog(CbaAlertDialogWebComponent, {
			closeButton: false,
			noMargin: true,
			noPadding: true,
			inputs: {
				data: {
					title: "Doublon de patient",
					alertType: "warning",
					alertTitle: "Fusionne ce nouveau patient avec l’existant ou modifie ta saisie.",
					alertSubTitle: `Un patient aux informations identiques a été créé le ${this.datePipe.transform(
						patientExistant?.creation,
						"dd/MM/yyyy",
					)}. Fusionne-les <br>ou assure-toi que les infos saisies sont correctes.`,
					confirmBtnText: "Confirmer la fusion",
					cancelBtnText: "Retourner à la saisie",
				},
			},
		});
		return await firstValueFrom(dialogRef.afterClosed());
	}
}
